import { cn } from "../../lib/utils"

/** Shared field styling for <Input> and input-like controls such as <TimePicker>. */
export const inputBaseClass = cn(
  "flex h-10 w-full rounded-lg border border-line-strong bg-canvas/60 px-3 text-sm text-fg",
  "shadow-[inset_0_1px_2px_rgb(0_0_0/0.3)] placeholder:text-fg-subtle",
  "transition-[border-color,box-shadow,background-color] duration-150",
  "hover:border-white/20 focus:border-brand focus:bg-canvas focus:outline-none focus:ring-3 focus:ring-brand/20",
  "disabled:cursor-not-allowed disabled:opacity-50"
)
